import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomNotificationsService } from '../../../common/services/custom-notifications.service';

@Component({
    selector: 'app-subscription-cancel-dialog',
    templateUrl: './subscription-cancel-dialog.component.html',
    standalone: false
})
export class SubscriptionCancelDialogComponent implements OnInit {
  @Input() dialogDetails: any;

  returnValue: any = { isSuccess: false };
  recordForm: FormGroup;
  requiredConfirmationMsg = '';

  constructor(
    public activeModal: NgbActiveModal,
    private notifyServ: CustomNotificationsService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.requiredConfirmationMsg =
      this.dialogDetails.confirmationMsg || 'I want to cancel my subscription';

    this.recordForm = this.fb.group({
      confMsg: [null],
    });
  }

  public accept(): void {
    this.returnValue.isSuccess = true;
    this.activeModal.close(this.returnValue);
  }

  public dismiss(): void {
    this.activeModal.dismiss();
  }

  onSubmit(): void {
    const formValue = this.recordForm.value;
    if (formValue.confMsg === this.requiredConfirmationMsg) {
      this.accept();
    } else {
      this.notifyServ.warning(
        'Please type the exact confirmation message to proceed.'
      );
    }
  }
}
